import { Box, BoxProps } from '@material-ui/core';
import { Currency, formatMoney } from '@nemuru-eng/js-api-client';
import { generatePath } from 'react-router';
import { Link } from 'react-router-dom';

import { HorizontalScoreCard } from '@/components/modules/Metrics/shared/components/HorizontalScoreCard';
import { MetricVariation } from '@/components/modules/Metrics/shared/components/MetricVariation';
import { MerchantScoreCardMetrics } from '@/components/modules/Metrics/shared/components/TopMerchants/types/MerchantScoreCardMetrics';
import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';
import { useTimeIntervalLabel } from '@/components/modules/Metrics/shared/hooks/useTimeIntervalLabel';
import { Font } from '@/components/shared/components/Font';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';

interface MerchantScoreCardProps extends BoxProps {
  index: number;
  currency: Currency;
  timeInterval: TimeInterval;
  metric: MerchantScoreCardMetrics;
}

export const MerchantScoreCard = ({ index, currency, timeInterval, metric, ...props }: MerchantScoreCardProps) => {
  const timeIntervalLabel = useTimeIntervalLabel(timeInterval);
  return (
    <HorizontalScoreCard
      hideDivider
      icon={
        <Box
          width={40}
          height={40}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          color={'secondary.main'}
        >
          <Font variant="h5">{index + 1}</Font>
        </Box>
      }
      title={
        <Link to={generatePath(DYNAMIC_PAGE_PATHS.MERCHANT, { merchantId: metric.merchantId })}>
          {metric.businessName}
        </Link>
      }
      subtitle={timeIntervalLabel}
      value={formatMoney({ value: metric.totalPrincipalAmount.current, currency }, 0)}
      subValue={<MetricVariation variation={metric.totalPrincipalAmount.variation} />}
      {...props}
    />
  );
};
